import { Breakpoint } from '@gousto-internal/citrus-react';

type RecipeImageSize =
  | 50
  | 200
  | 300
  | 350
  | 400
  | 450
  | 500
  | 600
  | 650
  | 700
  | 750
  | 800
  | 900
  | 1000
  | 1100
  | 1200
  | 1300
  | 1400
  | 1500;

const recipeImageCrops: RecipeImageSize[] = [500, 750, 1000, 1200, 1500];
const fallbackCrop: RecipeImageSize = 750;

function splitImageUrl(url: string): [base: string, extension: string] {
  const extensionIndex = url.lastIndexOf('.');
  const base = url.slice(0, extensionIndex);
  const extension = url.slice(extensionIndex + 1);
  return [base, extension];
}

export function getRecipeImageSizes(primaryUrl: string) {
  const [base, extension] = splitImageUrl(primaryUrl);

  return {
    srcset: recipeImageCrops.map((size) => `${base}-x${size}.${extension} ${size}w`).join(', '),
    src: `${base}-x${fallbackCrop}.${extension}`,
  };
}

export const recipeImageSizes = [
  `(max-width: ${Breakpoint.Small}) 500px`,
  `(max-width: ${Breakpoint.Medium}) 750px`,
  `(max-width: ${Breakpoint.Large}) 1000px`,
  `1200px`,
].join(', ');
